export { CarouselGridWrapper, CarouselItem } from '@sberdevices/plasma-core';
export type { CarouselItemProps } from '@sberdevices/plasma-core';

export { Carousel } from './Carousel';
export type { CarouselProps } from './Carousel';
